import React, { useState, useEffect } from "react";
import { getAI, getGenerativeModel, GoogleAIBackend } from "firebase/ai";
import { app } from "../config/firebase";

const FeedbackEvaluator = ({ answers }) => {
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(false);

  const evaluateAnswers = async () => {
    setLoading(true);
    const ai = getAI(app, { backend: new GoogleAIBackend() });
    const model = getGenerativeModel(ai, { model: "gemini-1.5-flash" });
    let prompt = `You are an interview coach. For each question and answer below, give a score (0-10), rephrase the answer for improvement, and provide feedback. Respond as JSON array: [{question, answer, score, improved, feedback}].\n\n`;

    Object.entries(answers).forEach(([question, answer], index) => {
      prompt += `Q${index + 1}: ${question}\nA${index + 1}: ${answer}\n`;
    });

    try {
      const response = await model.generateContent(prompt);
      const text = await response.response.text();
      const json = JSON.parse(text.match(/\[.*\]/s)?.[0] || text);
      setFeedback(json);
    } catch (error) {
      console.error("Error evaluating answers:", error);
      setFeedback([{ question: "Error", answer: "Could not evaluate answers." }]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Object.keys(answers).length > 0) {
      evaluateAnswers();
    }
  }, [answers]);

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-xl font-bold mb-4">AI Feedback</h2>
      {loading ? (
        <p>Loading feedback...</p>
      ) : (
        <ul className="space-y-4">
          {feedback.map((item, idx) => (
            <li key={idx} className="border-b pb-2">
              <div className="font-semibold text-gray-800">Q: {item.question}</div>
              <div className="text-gray-700">
                <span className="font-semibold">Your Answer:</span> {item.answer}
              </div>
              <div className="text-green-700">
                <span className="font-semibold">Improved:</span> {item.improved}
              </div>
              <div className="text-blue-700">
                <span className="font-semibold">Feedback:</span> {item.feedback}
              </div>
              <div className="text-purple-700">
                <span className="font-semibold">Score:</span> {item.score}/10
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FeedbackEvaluator;